import { render, staticRenderFns } from "./ProjectNameColumn.vue?vue&type=template&id=981be50a&"
import script from "./ProjectNameColumn.vue?vue&type=script&lang=js&"
export * from "./ProjectNameColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports